/**
 * Get currency symbol for a given currency code
 */
export function getCurrencySymbol(currency: string): string {
  const symbols: Record<string, string> = {
    USD: '$',
    ZAR: 'ZAR',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CNY: '¥',
    INR: '₹',
    AUD: 'A$',
    CAD: 'C$',
    CHF: 'CHF',
    NZD: 'NZ$',
    SGD: 'S$',
    HKD: 'HK$',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    PLN: 'zł',
    MXN: '$',
    BRL: 'R$',
    KRW: '₩',
    AED: 'د.إ',
    SAR: '﷼',
    THB: '฿',
    MYR: 'RM',
    IDR: 'Rp',
    PHP: '₱',
    VND: '₫',
    PKR: '₨',
    BDT: '৳',
    LKR: 'Rs',
  }
  return symbols[currency.toUpperCase()] || currency.toUpperCase()
}

/**
 * Format currency amount with code, grouping, and two decimals.
 * Example: ZAR 23,575.00
 */
export function formatCurrency(amount: number, currency: string): string {
  const value = Number(amount)
  const code = (currency || 'ZAR').toUpperCase()
  if (!Number.isFinite(value)) return `—`
  try {
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: code,
      currencyDisplay: 'code',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value)
  } catch {
    return `${code} ${value.toFixed(2)}`
  }
}
